import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Space, Row } from "@masterteam/mt-design-react";

import Modal from "../../Modal";
import Table from "../../NewTable";
import useIsAr from "../../../Hooks/useIsAr";
// import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";

import "./style.scss";

const KPIsListModal = ({ data, closeModal, isOpen }) => {
  const [isAr] = useIsAr();

  const columns = [
    {
      key: "title",
      header: <FormattedMessage id="common.title-kpis" />,
      cell: isAr ? "ArabicName" : "EnglishName",
    },
  ];

  return (
    <Modal isOpen={isOpen}>
      <Space
        direction="vertical"
        size="large"
        className="kpis-list-box-container"
      >
        {/* <div className="close-icon" onClick={closeModal}>
          <CloseIcon />
        </div> */}
        <div className="content-wrapper">
          <Table data={data} columns={columns} headerHasBackgroundColor />
        </div>

        <Row justify="end" size="medium">
          <Button variant="dark" type="button" onClick={closeModal}>
            <FormattedMessage id="common.close" />
          </Button>
        </Row>
      </Space>
    </Modal>
  );
};

export default KPIsListModal;
